if (!customElements.get('dynamic-atc-component')) {
  customElements.define(
    'dynamic-atc-component',
    class DynamicATCComponent extends HTMLElement {
      constructor() {
        super();
        this.qty = 1;
        this.product = null;
        this.variant = null;
        this.currentId = null;
        this.plan = null;
        this.planId = null;
      }

      toLocaleCurrency(str) {
        const locale = window.Shopify?.locale || 'en';
        const currency = window.Shopify?.currency?.active || 'USD';

        return str.toLocaleString(locale, {
          style: 'currency',
          currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      }

      setProduct(product) {
        if (!product) return;

        if (product.id === this.currentId) return; // already set

        this.currentId = product.id;

        if (window.Shopify?.pageType === 'product') {
          if (window.pdp?.product_object) {
            this.product = window.pdp.product_object;
          }
        }

        if (this.product.id !== this.currentId) {
          this.variant = product;
        }

        // Set price data
        this.dataset.otpPrice = this.variant.price;
        this.dataset.compareAtPrice = this.variant.compare_at_price;

        if (this.querySelector('.option-wrapper [data-value*="subscription"]')) {
          this.querySelector('.option-wrapper [data-value*="subscription"]').dataset.planId = this.planId;
        }

        if (this.querySelector('product-form input.product-variant-id')) {
          this.querySelector('product-form input.product-variant-id').setAttribute('value', this.currentId);
        }
      }

      setQty(qty) {
        if (qty) {
          this.qty = parseInt(qty);

          const form = this.querySelector('product-form form');

          if (form.querySelector('input[name="quantity"]')) {
            form.querySelector('input[name="quantity"]').setAttribute('value', this.qty);
            form.querySelector('input[name="quantity"]').value = this.qty;
          } else {
            const quantityInput = document.createElement('input');
            quantityInput.name = 'quantity';
            quantityInput.type = 'hidden';
            quantityInput.value = this.qty;

            form.insertAdjacentElement('afterbegin', quantityInput);
          }

          return this.qty;
        }
      }

      get isBuyBoxV2() {
        if (this.classList.contains('buy-box-v2')) return true;

        return (
          this.classList.contains('buy-box-v2-ready') &&
          document.documentElement.classList.contains('buy-box-v2-test')
        );
      }

      updateAll() {
        this.updateATCLabel();
        this.updatePriceLabels();
        this.updatePercentSavings();
      }

      connectedCallback() {
        let self = this;
        const isSticky = Boolean(self.dataset.stickyEnabled === 'true');

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this),
        );

        this.addEventListener('click', this.clickHandler.bind(self));

        this.querySelectorAll('.buy-box-v2__switch').forEach((switchButton) => {
          switchButton.addEventListener('click', this.switchHandler.bind(self));
        });

        if (this.classList.contains('buy-box-v2') || this.classList.contains('buy-box-v2-ready')) {
          this.onSectionRenderUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            if (self.isBuyBoxV2) self.updateATCLabel();
          });
        }

        this.updatePercentSavings();

        this.refillPrice =
          parseInt(this.dataset.refillPrice) ||
          parseInt(this.dataset.subPlanText?.split('<span>')[1]?.split('</span>')[0]?.replace(/[$,]+/g, '')) * 100 ||
          0;
        const planLabel = this.querySelector('.dynamic-atc__open-sub-selector--plan-label');

        if (this.refillPrice && planLabel) {
          planLabel.innerHTML = `$${this.refillPrice / 100} ${planLabel.innerHTML}`;
        }

        // set dimensional variables so there are no guesswork to be done by the css processor leading to weird layout overflows
        if (isSticky) {
          window.addEventListener('resize', this.updateDimensions.bind(this));
          this.updateDimensions();
        }

        setTimeout(() => {
          // if (this.dataset.isSticky !== 'true') {
          //   this.waitForStickyATC().then((el) => {
          //     this.observeIntersection(self);
          //   });
          // }
          if (isSticky) {
            this.observeIntersection(self);
            this.updateDimensions();
          }

          const subscriptionOption = this.querySelector('div.dynamic-atc__option[data-value*="subscription"]');
          const onetimeOption = this.querySelector('div.dynamic-atc__option[data-value="onetime"]');

          // The default selection below is programmatic: it must not be tracked as a shopper interaction.
          this.isAutoSelecting = true;
          if (subscriptionOption) {
            subscriptionOption.click();
          } else if (onetimeOption) {
            onetimeOption.click();
          } else {
            this.updateATCLabel();
          }
          this.isAutoSelecting = false;
        }, 300);
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.onSectionRenderUnsubscriber?.();
        this.removeEventListener('click', this.clickHandler);
      }

      updateDimensions() {
        let width = screen.width < window.innerWidth ? screen.width : window.innerWidth; // take the smaller width
        const setStickyBarWidth = (width) => {
          this.style.setProperty('--sticky-bar-width', `${width}px`);
        };
        const setPlansContainerWidth = (width) => {
          if (width < 750) {
            this.style.setProperty('--plans-container-width', `${width}px`);
          } else {
            this.style.setProperty('--plans-container-width', `500px`);
          }
        };
        const setBuyButtonContainerHeight = () => {
          this.style.setProperty(
            '--buy-button-container-height',
            `${this.querySelector('.buy-button-container').getBoundingClientRect().height - 1}px`,
          );
        };

        setStickyBarWidth(width);
        setPlansContainerWidth(width);
        setBuyButtonContainerHeight();
      }

      insertExtraRefillListItems() {
        const freeShipping = `<li>Free shipping for life!</li>`;
        if (this.dataset.refillPlanText) {
          const refillPlanText = `<li>${this.dataset.refillPlanText}</li>`;
          this.querySelector('.dynamic-atc__option .subscription-includes ul').insertAdjacentHTML(
            'beforeend',
            refillPlanText,
          );
          this.querySelector('.dynamic-atc__option .subscription-includes ul').insertAdjacentHTML(
            'beforeend',
            freeShipping,
          );
        }
      }

      switchHandler(e) {
        e.stopPropagation();

        const targetPlan = e.currentTarget.dataset.targetPlan;
        const selector =
          targetPlan === 'onetime'
            ? '.dynamic-atc__option[data-value="onetime"]'
            : '.dynamic-atc__option[data-value*="subscription"]';
        const targetOption = this.querySelector(selector);

        if (targetOption) targetOption.click();
      }

      updateATCLabel() {
        let subPrice = (parseInt(this.dataset.subPrice) / 100) * this.qty;
        let otpPrice = (parseInt(this.dataset.otpPrice) / 100) * this.qty;
        let isSubscribed = document.querySelector('[id*="MainProduct"]').dataset.subscribed === 'true' ? true : false;
        const compareValue = (parseInt(this.dataset.compareAtPrice) / 100) * this.qty;
        const comparePrice = this.toLocaleCurrency(compareValue);
        const isBuyBoxV2 = this.isBuyBoxV2;
        let price;

        if (!isSubscribed) {
          price =
            isBuyBoxV2 && compareValue > otpPrice
              ? `<s>${comparePrice}</s> ${this.toLocaleCurrency(otpPrice)}`
              : `${this.toLocaleCurrency(otpPrice)}`;
        } else if (isBuyBoxV2) {
          price =
            compareValue > subPrice
              ? `<s>${comparePrice}</s> ${this.toLocaleCurrency(subPrice)}`
              : `${this.toLocaleCurrency(subPrice)}`;
        } else {
          price = `${this.toLocaleCurrency(subPrice)} <s>${comparePrice}</s>`;
        }

        this.querySelector('.buy-button-container product-form button span').innerHTML = `Add To Cart — ${price}`;
      }

      updatePriceLabels() {
        let subPrice = (parseInt(this.dataset.subPrice) / 100) * this.qty;
        let otpPrice = (parseInt(this.dataset.otpPrice) / 100) * this.qty;

        if (this.querySelector('.sub-price .price .price--sub')) {
          this.querySelector('.sub-price .price .price--sub').innerHTML = this.toLocaleCurrency(subPrice);
        }
        this.querySelector('.otp-price .price').innerHTML = this.toLocaleCurrency(otpPrice);
        this.querySelector('.buy-button-container price-container').setQty(this.qty);
        if (this.variant) {
          this.querySelector('.buy-button-container price-container').setProduct(this.variant);
        } else {
          this.querySelector('.buy-button-container price-container').setProduct(this.product);
        }
        this.querySelector('.buy-button-container price-container').updatePrices();
      }

      // TODO: Feed it a product variant object
      updatePercentSavings() {
        if (!this.querySelector('.sub-price .savings')) return;
        const compareAtPrice = parseInt(this.dataset.compareAtPrice);
        const subPrice = parseInt(this.dataset.subPrice);
        const percentSaved = Math.round(((compareAtPrice - subPrice) * 100) / compareAtPrice);
        this.querySelector('.sub-price .savings').innerHTML = `Save ${percentSaved}%`;
      }

      waitForStickyATC() {
        const selector = 'dynamic-atc-component:has(.sticky-atc)';

        return new Promise((resolve) => {
          if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
          }

          const observer = new MutationObserver((mutations) => {
            if (document.querySelector(selector)) {
              observer.disconnect();
              resolve(document.querySelector(selector));
            }
          });

          observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
          });
        });
      }

      clickHandler(e) {
        const composedPath = e.composedPath();
        // console.debug('DynamicATCComponent.clickHandler', { composedPath })

        let self = false;
        let isSticky = false;
        let isDrawerToggle = false;
        let planOption = false;
        let optionsContainer = false;
        let isTooltipTrigger = false;

        for (const element of composedPath) {
          if (!element) return;

          if (element.matches && element?.matches('dynamic-atc-component')) {
            self = element;
          }
          if (element.matches && element?.matches('div.outer-wrapper.sticky-atc')) {
            isSticky = true;
          }
          if (element.matches && element?.matches('div.plan-drawer-toggle')) {
            isDrawerToggle = true;
          }
          if (element.matches && element?.matches('div.dynamic-atc__option')) {
            planOption = element;
          }
          if (element.matches && element?.matches('div.plan-selectors-container')) {
            optionsContainer = element;
          }
          if (element.matches && element?.matches('svg.info-icon')) {
            isTooltipTrigger = true;
          }
          if (element.matches && element?.matches('div.plan-tooltip-container')) {
            isTooltipTrigger = false;
          }
        }

        if (isDrawerToggle && isSticky) {
          self.querySelector('.plans-container').classList.toggle('drawer-open');
        }

        if (planOption) {
          let planId = null;
          let sellingPlanInput;
          // let currentId = this.currentId || this.variant?.id || this.product?.id || null

          if (planOption.dataset.value) {
            if (planOption.dataset.value === 'onetime') {
              document.querySelector('[id*="MainProduct"]').dataset.subscribed = 'false';
            } else {
              document.querySelector('[id*="MainProduct"]').dataset.subscribed = 'true';
              if (isNaN(planOption.dataset.planId) === false) {
                planId = planOption.dataset.planId;
              } else {
                planId = window.pdp.currentVariant.selling_plan_allocations[0].selling_plan_id;
              }
            }
          }

          let isOtp = document.querySelector('[id*="MainProduct"]').dataset.subscribed !== 'true';

          console.debug({ planId, product: this.product, variant: this.variant, isOtp });

          planOption.querySelector('input').checked = true;

          if (this.querySelector('product-form form input[name="selling_plan"]')) {
            sellingPlanInput = this.querySelector('product-form form input[name="selling_plan"]');
          } else {
            sellingPlanInput = document.createElement('input');
            sellingPlanInput.setAttribute('type', 'hidden');
            sellingPlanInput.setAttribute('name', 'selling_plan');
            sellingPlanInput.setAttribute('value', planId);

            this.querySelector('product-form form').appendChild(sellingPlanInput);
          }

          if (isOtp) {
            sellingPlanInput.setAttribute('value', '');
            if (document.querySelector('[id*="MainProduct"]')) {
              document.querySelector('[id*="MainProduct"]').dataset.subscribed = 'false';
              this.querySelector('.dynamic-atc__open-sub-selector--plan-label').innerHTML =
                `$${Number((this.dataset.otpPrice * this.qty) / 100)} One-time purchase.`;
            }
          } else {
            sellingPlanInput.setAttribute('value', planId);
            if (document.querySelector('[id*="MainProduct"]')) {
              document.querySelector('[id*="MainProduct"]').dataset.subscribed = 'true';

              this.querySelector('.dynamic-atc__open-sub-selector--plan-label').innerHTML =
                `Skip, pause, or cancel anytime.`;
            }
          }

          this.trackPurchaseOption(planId, isOtp);

          if (document.querySelector('product-info .product__info-container price-container').product) {
            this.querySelector('dynamic-atc-component price-container').setProduct(
              document.querySelector('product-info .product__info-container price-container').product,
            );
          }

          this.updatePriceLabels();
          setTimeout(() => {
            this.updateATCLabel();
            document.querySelector('product-info .product__info-container pricing-line').updateAll();
          }, 100);
        }

        if (self.querySelector('.plan-tooltip-container')) {
          if (isTooltipTrigger) {
            self.querySelector('.plan-tooltip-container.hidden')?.classList.remove('hidden');
          } else {
            if (self.querySelector('.plan-tooltip-container').classList.contains('hidden') === false) {
              self.querySelector('.plan-tooltip-container').classList.add('hidden');
            }
          }
        }

        publish(PUB_SUB_EVENTS.planChange, {
          source: 'dynamic-atc-component',
          isSubscribed: document.querySelector('[id*="MainProduct"]').dataset.subscribed === 'true',
        });
      }

      // purchase_option_select: subscription <-> one-time (or a different plan). Never on the default selection.
      trackPurchaseOption(planId, isOtp) {
        const purchaseType = isOtp ? 'one_time' : 'subscription';
        const sellingPlanId = isOtp || !planId ? '' : String(planId);
        const previous = this.currentPurchase;
        this.currentPurchase = { purchaseType, sellingPlanId };

        if (this.isAutoSelecting) {
          this.defaultPurchaseType = purchaseType;
          return;
        }

        const tracking = window.AutobrushTracking;
        if (!tracking || !previous) return;
        if (previous.purchaseType === purchaseType && previous.sellingPlanId === sellingPlanId) return;

        const product = window.pdp?.product_object;
        const variant = window.pdp?.currentVariant;
        const plans = (product?.selling_plan_groups || []).flatMap((group) => group.selling_plans || []);
        const plan = plans.find((candidate) => String(candidate.id) === sellingPlanId);
        const allocation = (variant?.selling_plan_allocations || []).find(
          (candidate) => String(candidate.selling_plan_id) === sellingPlanId,
        );
        const displayedPrice = isOtp ? variant?.price : allocation?.price;

        tracking.push('purchase_option_select', {
          item_id: product ? String(product.id) : '',
          variant_id: variant ? String(variant.id) : '',
          purchase_type: purchaseType,
          previous_purchase_type: previous.purchaseType,
          selling_plan_id: sellingPlanId,
          selling_plan_name: tracking.decodeHtml(plan?.name),
          displayed_price: tracking.toPrice(displayedPrice),
          default_purchase_type: this.defaultPurchaseType || '',
        });
      }

      handleOptionValueChange({ data }) {
        const { target } = data;
        if (target.tagName !== 'VARIANT-SELECTS') return;
        let currentVariant = JSON.parse(
          document.querySelector('product-info variant-selects [data-selected-variant]').textContent,
        );

        if (window.isThemePreview) {
          console.debug('handleOptionValueChange', { currentVariant, data });
        }

        if (currentVariant) {
          this.setProduct(currentVariant);
          this.updateAll();
        }
      }

      adjustSienna() {
        let buy_button = document.querySelector('.buy-button-container .product-form')
        let button_height = buy_button.clientHeight;
              
        document.body.classList.add('has-sticky-atc');
        document.body.style.setProperty('--sticky-height', `${button_height}px`);
        console.log('Setting sticky height to', `${button_height}px`);
      }

      observeIntersection(target) {
        function debounce(func, delay) {
          let timeout;
          return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), delay);
          };
        }

        
        const intersectionObserver = new window.IntersectionObserver(
          debounce(([entry]) => {
            if (!entry.isIntersecting) {
              // stickyCTA.classList.add('hidden');
              // target.classList.add('hidden');
              this.adjustSienna();

              target.querySelector('.outer-wrapper').classList.add('sticky-atc');
              this.updateDimensions();
            } else {
               document.body.classList.remove('has-sticky-atc');
              // stickyCTA.classList.remove('hidden');
              // target.classList.remove('hidden');
              target.querySelector('.outer-wrapper').classList.remove('sticky-atc');
              this.style.setProperty('--plans-container-height', `${this.getBoundingClientRect().height}px`);
            }

            // console.debug({ target, entry });
          }, 100),
          {
            root: null,
            rootMargin: '0px 0px 0px 0px',
            threshold: 0.25,
          },
        );

        intersectionObserver.observe(target);
      }
    },
  );
}
